export enum UserContentMenuOption {
    recent = 'recent',
    trackedRides = 'tracked rides',
    waypoints = 'waypoints',
    plannedRides = 'planned rides',
    geofences = 'geofences',
    collections = 'collections',
}
